import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function Works() {
  return (
    <div className="cnt-2" id="works">
      <div className="menu-title">Works</div>
      <div className="works-wrapper">
        <div className="w-content">
          <div className="works-cnt1 works-item">
            <a
              href="https://www.tv-tokyo.co.jp/youtuber_musume/"
              target="_blank"
              rel=""
            >
              <div className="w-img-1"></div>

              <div className="w-text-part">
                <div className="w-year">2022.1〜</div>
                <div className="w-title">
                  テレビ東京【ドラマプレミア23】
                  <br />
                  <span className="text-bold">
                    「ユーチューバーに娘はやらん！」
                  </span>
                  <br />
                  <br />
                  〈制作プロダクション〉
                  <br />
                  プロデューサー：高田良平、鎌倉希
                  <br />
                  監督：西浦正記
                </div>
              </div>
            </a>
          </div>

          <div className="works-cnt2 works-item">
            <a href="https://www.paravi.jp/title/83097/" target="_blank" rel="">
              <div className="w-img-2"></div>

              <div className="w-text-part">
                <div className="w-year2">2022.1〜</div>
                <div className="w-title">
                  Paraviオリジナル
                  <br />
                  <span className="text-bold">
                    「チャンネル登録お願いします！」
                  </span>
                  <br />
                  <br />
                  〈制作プロダクション〉
                  <br />
                  プロデューサー：高田良平、鎌倉希
                </div>
              </div>
            </a>
          </div>
          <div className="works-cnt3 works-item">
            <div className="coming-text1">Comming soon...</div>
          </div>
        </div>
      </div>
    </div>
  );
}
